module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/cover-8827d87c3eeade5930d5b32f47fbcea1.webp";